import script from "./NativeCloudPhoneView.vue?vue&type=script&setup=true&lang=js"
export * from "./NativeCloudPhoneView.vue?vue&type=script&setup=true&lang=js"

import "./NativeCloudPhoneView.vue?vue&type=style&index=0&id=006ceacc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-006ceacc"]])

export default __exports__